import React from 'react';
import { FileText } from 'lucide-react';
import { Helmet } from 'react-helmet';

const Terms = () => {
  return (
    <div className="min-h-screen bg-black text-white pt-32 pb-20">
      <Helmet>
        <link rel="canonical" href="https://www.flumberico.fun/terms" />
      </Helmet>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <FileText className="w-16 h-16 text-gold mx-auto mb-6" />
          <h1 className="text-5xl font-black mb-4 text-gold">
            Terms of Service
          </h1>
          <p className="text-silver/70">Last Updated: January 2025</p>
        </div>

        <div className="prose prose-invert prose-gold max-w-none">
          <section className="mb-10 bg-black/50 border border-gold/20 rounded-lg p-8">
            <h2 className="text-2xl font-bold text-gold mb-4">1. Acceptance of Terms</h2>
            <p className="text-white leading-relaxed">
              By accessing or using the FLUMBERICO website, participating in the SEO competition, or purchasing $FLUMBERICO tokens, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
            </p>
          </section>

          <section className="mb-10 bg-black/50 border border-silver/20 rounded-lg p-8">
            <h2 className="text-2xl font-bold text-silver mb-4">2. Description of Service</h2>
            <p className="text-white leading-relaxed mb-4">
              FLUMBERICO is a social experiment and meme coin project that rewards participants for creating backlinks to flumberico.fun. The service includes:
            </p>
            <ul className="list-disc list-inside text-white space-y-2 ml-4">
              <li>A cryptocurrency token ($FLUMBERICO) on the Solana blockchain</li>
              <li>An SEO competition to rank for the keyword "flumberico"</li>
              <li>A reward system based on link quality and domain authority</li>
              <li>Educational content about SEO and cryptocurrency</li>
            </ul>
          </section>

          <section className="mb-10 bg-black/50 border border-gold/20 rounded-lg p-8">
            <h2 className="text-2xl font-bold text-gold mb-4">3. Eligibility</h2>
            <p className="text-white leading-relaxed">
              You must be at least 18 years old and legally capable of entering into binding contracts to use our services. By using FLUMBERICO, you represent and warrant that you meet these requirements.
            </p>
          </section>

          <section className="mb-10 bg-black/50 border border-silver/20 rounded-lg p-8">
            <h2 className="text-2xl font-bold text-silver mb-4">4. Token Distribution and Rewards</h2>
            <p className="text-white leading-relaxed mb-4">
              Token distribution is subject to the following conditions:
            </p>
            <ul className="list-disc list-inside text-white space-y-2 ml-4">
              <li>Rewards are calculated based on domain authority, link quality, and other SEO metrics</li>
              <li>During the launch phase, distribution is manual and at the sole discretion of the developer</li>
              <li>The developer reserves the right to reject any link submission that violates these terms</li>
              <li>Token distribution timelines are estimates and not guaranteed</li>
              <li>No guarantee of specific reward amounts for any link submission</li>
            </ul>
          </section>

          <section className="mb-10 bg-black/50 border border-gold/20 rounded-lg p-8">
            <h2 className="text-2xl font-bold text-gold mb-4">5. Prohibited Activities</h2>
            <p className="text-white leading-relaxed mb-4">
              You agree not to engage in any of the following activities:
            </p>
            <ul className="list-disc list-inside text-white space-y-2 ml-4">
              <li>Using black-hat SEO techniques or link schemes</li>
              <li>Submitting fraudulent or misleading link information</li>
              <li>Creating spam or low-quality content</li>
              <li>Manipulating metrics or attempting to game the reward system</li>
              <li>Using automated bots or scripts without permission</li>
              <li>Violating any applicable laws or regulations</li>
              <li>Infringing on intellectual property rights</li>
            </ul>
          </section>

          <section className="mb-10 bg-black/50 border border-silver/20 rounded-lg p-8">
            <h2 className="text-2xl font-bold text-silver mb-4">6. No Investment Advice</h2>
            <p className="text-white leading-relaxed">
              Nothing on this website constitutes financial, investment, legal, or tax advice. $FLUMBERICO is an experimental meme coin and should not be considered an investment. Any information provided is for educational and entertainment purposes only. Always consult with qualified professionals before making financial decisions.
            </p>
          </section>

          <section className="mb-10 bg-black/50 border border-gold/20 rounded-lg p-8">
            <h2 className="text-2xl font-bold text-gold mb-4">7. Risk Acknowledgment</h2>
            <p className="text-white leading-relaxed">
              You acknowledge and accept that cryptocurrency investments carry substantial risk, including but not limited to the risk of complete loss of value, regulatory changes, technical failures, and market volatility. You participate at your own risk.
            </p>
          </section>

          <section className="mb-10 bg-black/50 border border-silver/20 rounded-lg p-8">
            <h2 className="text-2xl font-bold text-silver mb-4">8. Intellectual Property</h2>
            <p className="text-white leading-relaxed">
              All content, logos, trademarks, and materials on this website are the property of FLUMBERICO or its licensors. You may not use, reproduce, or distribute any content without express written permission.
            </p>
          </section>

          <section className="mb-10 bg-black/50 border border-gold/20 rounded-lg p-8">
            <h2 className="text-2xl font-bold text-gold mb-4">9. Limitation of Liability</h2>
            <p className="text-white leading-relaxed">
              To the maximum extent permitted by law, FLUMBERICO and its developers shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including but not limited to loss of profits, data, or other intangible losses resulting from your use of our services.
            </p>
          </section>

          <section className="mb-10 bg-black/50 border border-silver/20 rounded-lg p-8">
            <h2 className="text-2xl font-bold text-silver mb-4">10. Modifications to Service</h2>
            <p className="text-white leading-relaxed">
              We reserve the right to modify, suspend, or discontinue any part of the service at any time without prior notice. We are not liable to you or any third party for any modification, suspension, or discontinuation of the service.
            </p>
          </section>

          <section className="mb-10 bg-black/50 border border-gold/20 rounded-lg p-8">
            <h2 className="text-2xl font-bold text-gold mb-4">11. Governing Law</h2>
            <p className="text-white leading-relaxed">
              These Terms shall be governed by and construed in accordance with applicable international laws. Any disputes shall be resolved through binding arbitration.
            </p>
          </section>

          <section className="mb-10 bg-black/50 border border-silver/20 rounded-lg p-8">
            <h2 className="text-2xl font-bold text-silver mb-4">12. Contact Information</h2>
            <p className="text-white leading-relaxed">
              For questions about these Terms of Service, please contact us through our official social media channels or community forums.
            </p>
          </section>
        </div>

        <div className="mt-12 text-center bg-gold/10 border border-gold/30 rounded-lg p-6">
          <p className="text-white">
            By using FLUMBERICO, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Terms;